import { type SelectItem } from './types'

const shirtSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL']

export const SHIRT_SIZES: SelectItem[] = shirtSizes.map((item) => ({
  label: `${item}`,
  value: item,
}))
